import { MenuItem } from "../ApplicationLayout";
import { PersonaType } from "../../context/ApplicationContext";
import { investorMenuItems, otherMenuItems } from "./investor";
import { founderMenuItems } from "./founder";
import { FiUsers, FiBookOpen } from "react-icons/fi";

/**
 * Placeholder menu for ACCELERATOR persona
 */
export const acceleratorMenuItems: MenuItem[] = [
  {
    menuLabel: "Programs",
    icon: <FiUsers />,
    items: [
      { to: "programs", menuLabel: "My Programs" },
      { to: "startups", menuLabel: "Startups" },
    ],
  },
];

/**
 * Placeholder menu for ACADEMIA persona
 */
export const academiaMenuItems: MenuItem[] = [
  {
    menuLabel: "Research",
    icon: <FiBookOpen />,
    items: [
      { to: "research", menuLabel: "Research Tools" },
      { to: "data", menuLabel: "Data Access" },
    ],
  },
];

/**
 * Placeholder menu for DFI_GOVT persona
 */
export const dfiGovtMenuItems: MenuItem[] = [
  {
    menuLabel: "Programs",
    icon: <FiUsers />,
    items: [
      { to: "programs", menuLabel: "Programs" },
      { to: "analytics", menuLabel: "Analytics" },
    ],
  },
];

/**
 * Get menu items based on user persona
 * @param persona - User persona type
 * @returns Menu items array for the persona
 */
export const getMenuForPersona = (persona: PersonaType): MenuItem[] => {
  switch (persona) {
    case "FOUNDER":
      return founderMenuItems;
    case "INVESTOR":
    case "ACCELERATOR":
      // Use INVESTOR menu for all non-FOUNDER personas for now
      return investorMenuItems;
    case "ACADEMIA":
    case "DFI_GOVT":
      return otherMenuItems;
    default:
      return founderMenuItems;
  }
};
